import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-bottom: 4px solid #000fff;
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;

  @media (max-width: 770px) {
    min-width: 100%;
    max-width: 100%;
  }
`;

export const IconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
`;

export const IconImage = styled.img`
  width: 28px;
  height: auto;
`;

export const Title = styled.h3`
  font-size: 13px;
  font-weight: 500;
  color: #333333;
  margin: 0;
`;

export const Value = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #000fff;
  margin: 2px 0;
`;

export const Description = styled.p`
  font-size: 11px;
  color: #808080;
  margin: 0;
  line-height: 1.3;

  strong {
    font-weight: 600;
    color: #333333;
  }
`;
